import { createApp } from 'vue';
import App from './App.vue'
import router from './router'
import store from './store'
import { BIconArrowRepeat, BIconXLg } from 'bootstrap-icons-vue';

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";

const app = createApp(App)
    .use(router)
    .use(store)
    .component('BIconArrowRepeat', BIconArrowRepeat)
    .component('BIconXLg', BIconXLg)
    .mount('#app');

app.$store.dispatch("init");